import React, { useMemo, useState } from 'react';
import { MetaDataItem } from './TherapistDetail';
// @ts-ignore
import styles from './TherapistDetail.module.scss';
import LinkButton from '../../../../../Components/Button/LinkButton';
import { Theme } from '../../../../../Enums/Theme.enum';
import useTranslation from '../../../../../Hooks/useTranslation';
import UserMetaDataEdit from '../../../../Meta/Components/UserMetaDataEdit/UserMetaDataEdit';
import TherapistLanguageEdit from './TherapistLanguageEdit';
import NoEscape from '../../../../../Components/NoEscape';
import TherapistInsuranceCompaniesEdit from './TherapistInsuranceCompaniesEdit';

interface Props {
	item: MetaDataItem;
	onEditSuccess: () => void;
	userId: string;
}

const TherapistDetailItem: React.FC<Props> = ({
	item,
	onEditSuccess,
	userId,
}) => {
	const [isEditOpen, setIsEditOpen] = useState(false);
	const { t } = useTranslation();

	const handleAfterEditSuccess = () => {
		setIsEditOpen(false);
		onEditSuccess();
	};

	const value = useMemo(() => {
		if (item.value) {
			if (item.printValue) {
				return item.printValue;
			}
			return item.value;
		}
		return t('base.shared.unfilled');
	}, [item]);

	const editComponent: React.ReactElement = useMemo(() => {
		switch (item.key) {
			case 'language':
				return (
					<TherapistLanguageEdit
						defaultValues={item.defaultValues}
						onSuccess={handleAfterEditSuccess}
						userId={userId}
					/>
				);
			case 'insuranceCompanies':
				return (
					<TherapistInsuranceCompaniesEdit
						defaultValues={item.defaultValues}
						onSuccess={handleAfterEditSuccess}
						userId={userId}
					/>
				);
			default:
				return (
					<UserMetaDataEdit
						userId={userId}
						metaDataItem={item}
						onSuccess={handleAfterEditSuccess}
					/>
				);
		}
	}, [item]);

	return (
		<div className={styles.item}>
			{isEditOpen ? (
				editComponent
			) : (
				<>
					<div className={styles.titleWrapper}>
						<div className={styles.title}>{t(item.title)}</div>
						<div>
							<LinkButton
								title={'base.shared.edit'}
								theme={Theme.BLUE}
								onClick={() => setIsEditOpen(true)}
								firstUpper
							/>
						</div>
					</div>
					<div>
						<NoEscape>{value}</NoEscape>
					</div>
				</>
			)}
		</div>
	);
};

export default TherapistDetailItem;
